import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import FormFieldBase from '../FieldBase';
import TextBase from './TextBase';

var TextField = function TextField(_ref) {
  var name = _ref.name,
      rest = _objectWithoutProperties(_ref, ["name"]);

  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name
  }, rest));
};

TextField.defaultProps = {
  margin: 'normal',
  type: 'text',
  component: TextBase,
  fullWidth: true
};
export default TextField;